import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { LrUpdateService } from "../../../services/index";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditLorryUpdate.html",
})
export class AddEditLorryUpdate implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();
  @Input()
  checked: boolean;

  mode = "Add";
  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  @Input() invdata: any = {
    lr_id: "",
    freight_charge: 0,
    cooly_amt: 0,
    others: 0,
  };

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    if (this.mode == "Edit" || this.mode == "Return") {
      let invdata = Object.assign({}, val["data"]);

      this.invdata = invdata;
      this.invdata["invdt"] = new Date(
        ("" + this.invdata["invoice_date"]).replace(
          /(\d{2})-(\d{2})-(\d{4})/,
          "$2/$1/$3"
        )
      );
      this.editUpdateList(this.invdata.lr_update_id);
      this.onselecttransport(this.invdata.transport);

      /* this.onselectrefno(this.invdata.ref_no);
        this.onselectlrno(this.invdata.lr_no) */
    }
  }

  get params(): any[] {
    return this._params;
  }

  refnoList: any = [];
  lrDetList: any = [];
  selectedLr = [];

  lrList = [
    {
      ref_no: "",
      lr_no: "",
      invoice_no: "",
      no_of_bundle: 0,
      lr_amount: "",
      rec_no: "",
      rec_date: "",
      act_wt: "",
      rec_wt: "",
    },
  ];
  transportList: any = [];
  itemCtrl: FormControl;
  //  rateCtrl: FormControl = new FormControl();
  isLoading: boolean = false;
  @ViewChild("itemForm") itemForm;
  @ViewChild("lorryAuto") lorryAuto;
  @ViewChild("transAuto") transAuto;
  invCtrl: FormControl = new FormControl();
  shipCtrl: FormControl = new FormControl();
  invoicelist: any;
  lrnoList: any;
  invnoList: any;
  list: any;
  // companyInfo : any = [];
  //  uomCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private lrupdateService: LrUpdateService,
    public toasterService: ToasterService
  ) {
    // this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
  }

  ngOnInit() {
    if (this.mode == "Add") {
      this.invdata.lr_update_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAuto();
    }
    this.tableScroll();
    this.transportlist();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#transport").focus();
    }, 100);
  }

  tableScroll() {
    $(".lrbody").height(window.innerHeight - 350);
    $(".lrbody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string): void {
    $("#" + this.page_id + nextEl).focus();

    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design = this.lrList[ind]["design_no"],
      qtyval = this.lrList[ind]["qty"],
      amount = this.lrList[ind]["amt"],
      gst = this.lrList[ind]["gst"],
      gstamt = this.lrList[ind]["gstamt"],
      qty = this.lrList[ind]["qty"],
      rateval = this.lrList[ind]["rate"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "ref_no" && nxtRow.length == 0) {
      let len = this.lrList.length;

      this.lrList.push({
        ref_no: "",
        lr_no: "",
        invoice_no: "",
        no_of_bundle: 0,
        lr_amount: "",
        rec_no: "",
        rec_date: "",
        act_wt: "",
        rec_wt: "",
      });
      $("#" + this.page_id + "lr_no").focus();
    }
    nxtInd = this.lrList.length - 1;
    setTimeout(() => {
      $("#" + this.page_id + fld + "-" + nxtInd).focus();
    }, 100);
  }

  getAuto() {
    this.lrupdateService.getUpdateAuto({}).then((res: any) => {
      if (this.mode == "Add") {
        this.invdata.update_no = res;
      }
    });
  }

  editUpdateList(id) {
    let params = {
      update_id: id,
      mode  : this.mode
    };
    this.lrupdateService.editUpdateList(params).then((res: any) => {
      this.lrList = res.data;
      if (res) {
        this.calcamt();
        this.calcTotal();
      }
    });
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onGoToRightAndLeft($event, fld, arrow, ind) {
    if (arrow == "Right") {
    }
    if (arrow == "Left") {
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }
  onkeydown($event, arrow, ind, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if (arrow == "up") {
      ind--;
    } else {
      ind++;
    }
    if (ind < 0) {
      $("#" + this.page_id + "discount").focus();
    } else if (ind < 0) {
      $("#" + this.page_id + "item-0").focus();
    }

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  onupanddown($event, fld, arrow) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") {
      if (fld == "item") {
        $("#" + this.page_id + "item-0").focus();
      } else {
        $("#" + this.page_id + "discount").focus();
      }
    } else {
      if (fld == "gstamnt") {
        $("#" + this.page_id + "gstamnt").focus();
      } else if (fld == "gstper") {
        $("#" + this.page_id + "gstper").focus();
      } else {
        $("#" + this.page_id + "amnt-0").focus();
      }
    }
  }

  /*  getLrDesignList(lr_id){
        let params= {
            lr_id: lr_id
        }
        this.lrupdateService
        .getLrDesignList(params)
        .then((res: any) => {

         this.lrList = res.data;
        });

    } */

  transportlist() {
    this.lrupdateService.transportlist({}).then((res: any) => {
      this.transportList = res.data;
      this.transportList = this.transportList.filter(
        (el) => el.transport != ""
      );
    });
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
      return 0.0;
    let no = parseInt(nStr).toFixed(2);
    /*if (no < 0) {
            nStr = no * -1;
        }
        nStr += '';*/

    let x = no.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = x1.length;
    let num = len / 2 - 1;

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      } else {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      num--;
      if (num == 0) {
        break;
      }
    }

    let out = x1 + x2;
    // if (Number(no) < 0) {
    //     out = "(" + out + ")";
    // }
    return out;
  }

  loadRefnoList(name) {
    for (let i = 0; i < this.lrList.length; i++) {
      this.lrList[i]["lr_no"] = "";
      this.lrList[i]["inv_id"] = "";
      this.lrList[i]["Plr_id"] = "";
      this.lrList[i]["invoice_no"] = "";
      this.lrList[i]["party_id"] = "";
      this.lrList[i]["party_name"] = "";
      this.lrList[i]["pvt_mark"] = 0;
      this.lrList[i]["no_of_bales"] = 0;
      this.lrList[i]["lr_amount"] = "";
      this.lrList[i]["tds_amount"] = 0;
      this.lrList[i]["net_amount"] = 0;
      this.lrList[i]["rec_no"] = "";
      this.lrList[i]["rec_date"] = "";
    }
    this.lrList.splice(1, this.lrList.length);

    let params = {
      transport: name,
    };
    this.lrupdateService.getRefnoList(params).then((res: any) => {
      this.refnoList = res.data;
    });
  }

  onselectrefno(refno) {
    this.lrnoList = _.filter(this.refnoList, { ref_no: refno });
  }
  onselectlrno(lrno) {
    this.invnoList = _.filter(this.lrnoList, { lr_no: lrno });
  }

  onenterInvNo(invno, ind) {
    this.list = _.filter(this.invnoList, { invoice_no: invno });
    this.lrList[ind]["no_of_bundle"] = this.list[0].no_of_bales;
    this.lrList[ind]["act_wt"] = this.list[0].act_wt;
    this.lrList[ind]["lr_amount"] = this.list[0].lr_amount;
    this.lrList[ind]["inv_id"] = this.list[0].inv_id;
    this.calcamt();
  }

  calcamt() {
    let amt = 0;
    for (let i = 0; i < this.lrList.length; i++) {
      let data = this.lrList[i];
      amt += parseFloat(data.lr_amount);
      // amt+=this.lrList[i].lr_amount;
    }
    this.invdata.amount = amt;
    this.calcTotal();
    console.log(this.invdata.amount);
  }
  calcTotal() {
    let freight = this.invdata.freight_charge || 0,
      coolie = this.invdata.cooly_amt || 0,
      others = this.invdata.others || 0;

    this.invdata.total_amt = this.invdata.amount + freight + coolie + others;
    this.invdata.total_amt = this.moneyFormat(this.invdata.total_amt);
  }

  /*  loadLrdetails() {
        let params = {};
        this.lrupdateService
            .getLRDetails(params)
            .then((res: any) => {

                this.invdata = res.data;

            });

    }
  */
  changedateFormat(date, ind) {
    this.lrList[ind].rec_date = this.datePipe.transform(date, "yyyy-MM-dd");
  }

  onselecttransport(trans) {
    this.loadRefnoList(trans);
  }

  /* onselectlrno($event,ind) {
         this.lrList[ind].Plr_id = $event.item.plr_id;
          let invList = _.filter(this.lrnoList, { lr_no: $event.item.lr_no });
          this.invoicelist = invList;
        //this.invdata.Plr_id = id;
    } */

  oncheckemptyrow() {
    let design = this.lrList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].ref_no != "") {
        desList.push(design[i]);
      }
    }
    this.lrList = desList;
    this.onSaveLrUpdate();
  }

  returnLr(){
    if(this.selectedLr.length > 0){

      let params: any = Object.assign({}, this.selectedLr);
     
      let that = this;

      swal({
        title: "Are you sure to return these LR(s)?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, return it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.lrupdateService
          .returnLr(params)
          .then(function (res: any) {
            that.isLoading = false;

            if (res) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Return") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });

    }else{
      swal("Please select atleast one LR");
    }
  }

  /*  onClickInv(inv,ind){
         let list = _.filter(this.invoicelist, { invoice_no: inv,plr_id:this.lrList[ind].Plr_id});
         this.lrList[ind].party_name = list[0]['party_code'];
         this.lrList[ind].pvt_mark = list[0]['pvt_mark'];
         this.lrList[ind].no_of_bales = list[0]['no_of_bales'];
         this.lrList[ind].lr_amount = list[0]['lr_amount'];
         this.lrList[ind].inv_id = list[0]['inv_id'];
         this.lrList[ind].party_id = list[0]['party_id'];
         this.lrList[ind].act_wt = list[0]['act_wt'];
         this.lrList[ind].chr_wt =list[0]['chr_wt'];
             } */
  onClickReturn(event,inv_id) {

    if(event.checked){
      this.selectedLr.push(inv_id);
    }else{
      this.selectedLr = this.selectedLr.filter(el => el != inv_id );
    }
   
  }
  onSaveLrUpdate(): void {
    let design = this.lrList;
    for (let i = 0; i < design.length; i++) {
      if (
        design[i].rec_date == "" ||
        design[i].rec_no == "" ||
        design[i].rec_wt == ""
      ) {
        swal("Check whether all the details are entered or not!");
      } else {
        let params: any = Object.assign({}, this.invdata);
        params["lrList"] = JSON.stringify(this.lrList);
        params["tabevent"] = undefined;
        params["lr_update_date"] = this.datePipe.transform(
          params["lr_update_date"],
          "yyyy-MM-dd"
        );
        let that = this;

        swal({
          title: "Are you sure to save this Details?",
          type: "success",
          showCancelButton: true,
          confirmButtonText: "Yes, save it!",
          cancelButtonText: "No, want to change",
        }).then(function () {
          that.isLoading = true;
          that.lrupdateService
            .savelorryUpdate(params)
            .then(function (res: any) {
              that.isLoading = false;

              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lorryUpdate/addEditLorryUpdate.ts